import { render, staticRenderFns } from "./RelatorioDeAbsenteismo.vue?vue&type=template&id=334fedae"
import script from "./RelatorioDeAbsenteismo.vue?vue&type=script&lang=js"
export * from "./RelatorioDeAbsenteismo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDeAbsenteismo.vue?vue&type=style&index=0&id=334fedae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports